export const buttonStyle = (theme, enabled = false)=> ({
    margin: "0 " + (theme.spacing.unit-3) + " 0 0",
    width: '40px',
    borderRadius: 0,
    height: '41px',
    minWidth: 'auto',
    color: (enabled ? '#fff' : '#00264A'),
    backgroundColor: (enabled ? '#00264A' : '#fff'),
    padding: '0 8px',
    boxShadow: theme.shadows[3],
    '&:hover': {
      background: theme.palette.action.hover,
      color: theme.palette.action.hoverText
    }
});

export const dropButtonStyle = (theme)=> ({
    backgroundColor: '#fff',
    fontWeight: 'normal',
    borderBottom: '1px solid #d0d0d0',
    boxShadow: theme.shadows[2],
    color: theme.palette.gray,
    height: '36px',
    padding: '0 16px',
    width: '244px',
    '&:hover': {
      background: '#e6e6e6',
      color: theme.palette.gray
    }
  });